var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNormalScholarshipsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 13.302,
    viewBox: "0 0 19 13.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "graduation-cap-solid_1_",
    "data-name": "graduation-cap-solid (1)",
    d: "M9.485,32a2.1,2.1,0,0,0-.7.122L.454,35.129a.714.714,0,0,0,0,1.342l1.719.62a4.887,4.887,0,0,0-.763,2.624v.834a5.632,5.632,0,0,1-.662,2.4A7.871,7.871,0,0,1,.08,44.065a.476.476,0,0,0,.264.748l1.9.475a.473.473,0,0,0,.368-.059.465.465,0,0,0,.211-.309,7.654,7.654,0,0,0-.062-3.227,6.565,6.565,0,0,0-.4-1.247v-.73A3.942,3.942,0,0,1,3.188,37.3a3.625,3.625,0,0,1,1.461-1.06L9.31,34.4a.474.474,0,0,1,.347.882L5,37.118a2.725,2.725,0,0,0-.956.641l4.738,1.71a2.094,2.094,0,0,0,1.407,0l8.33-3a.714.714,0,0,0,0-1.342l-8.327-3.007A2.1,2.1,0,0,0,9.485,32Zm-5.7,11.162c0,1.048,2.553,2.137,5.7,2.137s5.7-1.09,5.7-2.137l-.454-4.316-4.221,1.526a3.034,3.034,0,0,1-2.048,0L4.239,38.846Z",
    transform: "translate(0.016 -32)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalScholarshipsIcon);
export default __webpack_public_path__ + "static/media/normal-scholarships-icon.3f40bfe8a231fac03c89afcd41d96efb.svg";
export { ForwardRef as ReactComponent };